'use strict';

const isInstanceOf = require('../rlink-type-utils/isInstanceOf');

const keySymbol = Symbol('mapOf.keySymbol');
const valueSymbol = Symbol('mapOf.valueSymbol');

module.exports = function mapOf (keyChecker, valueChecker, ...args) {
  const checker = (obj, key, cname, location, fullName) => {
    // this is the proptype protocol: value can always be accessed like this
    const value = obj[key];
    if (!isInstanceOf(value, Map)) {
      return new TypeError(`Value at ${fullName} is not a Map!`);
    }

    for (let [mapKey, mapValue] of value) {
      // how about..
      const checkObj = { [valueSymbol]: mapKey, [valueSymbol]: mapValue };

      const keyCheck = keyChecker(checkObj, valueSymbol, cname, location, `${fullName}<@@${mapKey}@@>`);
      if (keyCheck) {
        return keyCheck;
      }

      const valueCheck = valueChecker(checkObj, valueSymbol, cname, location, `${fullName}<${mapKey}>`);
      if (valueCheck) {
        return valueCheck;
      }
    }

    return null;
  };

  checker.getCheckerForKey = () => valueChecker;
  checker.makeNew = () => new Map();
  checker.checkerName = 'arrayOf';

  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }

  if (typeof valueChecker !== 'function') {
    throw new Error(`Invalid checker for ${checker.checkerName}: ${valueChecker}`);
  }

  if (!valueChecker.checkerName) {
    throw new Error(`Non-rlink-shape checker for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
  }

  return checker;
};

module.exports.keySymbol = keySymbol;
module.exports.valueSymbol = valueSymbol;



// WEBPACK FOOTER //
// ./lib/rlink-shapes/mapOf.js